export default __webpack_public_path__ + "static/media/bglogin.558655aa.jpg";